<template>
  <node-view-wrapper class="html-block-node" as="div" dir="ltr">
    <div class="html-block-node__bar" contenteditable="false">
      <span class="html-block-node__badge">HTML</span>
      <div class="html-block-node__actions">
        <button
          type="button"
          class="html-block-node__btn"
          :class="{ active: editing }"
          @click="editing = !editing"
        >
          {{ editing ? 'پیش‌نمایش' : 'ویرایش' }}
        </button>
      </div>
    </div>

    <textarea
      v-if="editing"
      ref="textarea"
      class="html-block-node__editor"
      :value="node.attrs.html"
      spellcheck="false"
      dir="ltr"
      @input="onInput"
      @keydown.stop
      @mousedown.stop
    ></textarea>
    <div
      v-else
      class="html-block-node__preview"
      dir="auto"
      v-html="previewHtml"
    ></div>
  </node-view-wrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-2'

export default {
  name: 'HtmlBlockView',
  components: { NodeViewWrapper },
  props: nodeViewProps,
  data() {
    return {
      editing: !((this.node && this.node.attrs && this.node.attrs.html) || '').trim()
    }
  },
  computed: {
    previewHtml() {
      const html = String((this.node && this.node.attrs && this.node.attrs.html) || '').trim()
      return html || '<p class="html-block-node__empty">بلوک HTML خالی — روی ویرایش بزنید</p>'
    }
  },
  watch: {
    editing(value) {
      if (value) {
        this.$nextTick(() => {
          const el = this.$refs.textarea
          if (!el) return
          el.focus()
          el.style.height = 'auto'
          el.style.height = `${Math.max(120, el.scrollHeight)}px`
        })
      }
    }
  },
  methods: {
    onInput(event) {
      const html = event.target.value
      this.updateAttributes({ html })
      event.target.style.height = 'auto'
      event.target.style.height = `${Math.max(120, event.target.scrollHeight)}px`
    }
  }
}
</script>

<style>
.html-block-node {
  margin: 0.85rem 0;
  border: 1px dashed #64748b;
  border-radius: 10px;
  background: #0f172a;
  overflow: hidden;
}

.html-block-node__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.4rem 0.65rem;
  background: #1e293b;
  border-bottom: 1px solid #334155;
}

.html-block-node__badge {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #38bdf8;
  font-family: Consolas, 'Courier New', monospace;
}

.html-block-node__actions {
  display: flex;
  gap: 0.35rem;
}

.html-block-node__btn {
  border: 1px solid #475569;
  background: #334155;
  color: #e2e8f0;
  border-radius: 6px;
  padding: 0.2rem 0.55rem;
  font-size: 0.75rem;
  cursor: pointer;
  line-height: 1.4;
}

.html-block-node__btn:hover,
.html-block-node__btn.active {
  background: #0284c7;
  border-color: #0284c7;
  color: #fff;
}

.html-block-node__editor {
  display: block;
  width: 100%;
  min-height: 120px;
  padding: 0.75rem 0.85rem;
  border: none;
  outline: none;
  resize: vertical;
  background: #0f172a;
  color: #e2e8f0;
  font-family: Consolas, 'Courier New', ui-monospace, monospace;
  font-size: 0.8125rem;
  line-height: 1.65;
  box-sizing: border-box;
  direction: ltr;
  text-align: left;
}

.html-block-node__preview {
  padding: 0.85rem 1rem;
  background: #fff;
  color: #12121f;
  min-height: 2.5rem;
  line-height: 1.7;
}

.html-block-node__preview .html-block-node__empty {
  margin: 0;
  color: #94a3b8;
  font-size: 0.85rem;
}

.dark .html-block-node__preview {
  background: #18181b;
  color: #f4f4f5;
}
</style>
